import { render } from "./WrongQuestionsView.vue?vue&type=template&id=06c01477&scoped=true"
import script from "./WrongQuestionsView.vue?vue&type=script&lang=js"
export * from "./WrongQuestionsView.vue?vue&type=script&lang=js"

import "./WrongQuestionsView.vue?vue&type=style&index=0&id=06c01477&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c01477"]])

export default __exports__